export default __webpack_public_path__ + "static/SegoeUI-Light-a4cb537856834f0a73b1eab3ae70b93a.ttf";